function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80%,40%,60%)",
      fillOpacity: 1
    },
    d: "M 4.5 0 L 25.5 0 C 27.984375 0 30 2.015625 30 4.5 L 30 25.5 C 30 27.984375 27.984375 30 25.5 30 L 4.5 30 C 2.015625 30 0 27.984375 0 25.5 L 0 4.5 C 0 2.015625 2.015625 0 4.5 0 Z M 4.5 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.117188 5.15625 C 9.492188 7.089844 5.859375 11.015625 6.210938 13.359375 C 6.5625 15.703125 10.078125 17.578125 11.660156 18.808594 C 9.609375 19.863281 7.03125 21.445312 7.089844 23.496094 C 7.207031 26.308594 10.253906 25.429688 11.542969 24.609375 C 12.832031 23.789062 14.121094 21.503906 13.300781 19.101562 C 15.117188 18.632812 16.699219 19.21875 17.167969 19.570312 C 18.984375 20.859375 18.046875 22.324219 17.402344 22.558594 C 16.757812 22.792969 17.167969 22.910156 17.578125 22.792969 C 17.988281 22.675781 18.867188 22.089844 18.867188 21.09375 C 18.867188 18.574219 16.171875 17.402344 12.832031 18.28125 C 10.898438 16.230469 8.261719 15.292969 8.378906 13.066406 C 8.4375 12.246094 8.730469 10.136719 13.945312 7.5 C 19.160156 4.863281 22.851562 5.917969 22.382812 8.320312 C 21.679688 11.953125 15.351562 14.414062 13.125 12.304688 C 13.007812 12.070312 12.597656 11.894531 12.832031 12.539062 C 14.003906 15.46875 23.496094 14.121094 23.90625 7.910156 C 24.023438 4.628906 19.277344 3.75 15.117188 5.15625 Z M 10.078125 23.90625 C 8.613281 24.375 8.671875 23.4375 8.730469 23.085938 C 8.90625 22.089844 9.726562 20.859375 12.1875 19.628906 C 12.890625 21.855469 11.308594 23.554688 10.078125 23.90625 Z M 10.078125 23.90625 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSass);
export default __webpack_public_path__ + "static/media/sass.a55e5e6b870ec7ac11daaaa8f19035fe.svg";
export { ForwardRef as ReactComponent };